/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getStaff = /* GraphQL */ `
  query GetStaff($id: ID!) {
    getStaff(id: $id) {
      id
      name
      active
      createdAt
      updatedAt
    }
  }
`;
export const listStaffs = /* GraphQL */ `
  query ListStaffs(
    $filter: ModelStaffFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStaffs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        active
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getTimeSheet = /* GraphQL */ `
  query GetTimeSheet($id: ID!) {
    getTimeSheet(id: $id) {
      id
      staffID
      arrivalTime
      departureTime
      createdAt
      updatedAt
    }
  }
`;
export const listTimeSheets = /* GraphQL */ `
  query ListTimeSheets(
    $filter: ModelTimeSheetFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTimeSheets(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        staffID
        arrivalTime
        departureTime
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getInvoice = /* GraphQL */ `
  query GetInvoice($id: ID!) {
    getInvoice(id: $id) {
      id
      createdAt
      updatedAt
      paymentDate
      insurer
      claimNo
      patient
      provider
      amount
      paymentType
      note
      invoiceDoc
      chequeDoc
      status
      claimDisbursedToProvider
      createdBy
      updatedBy
    }
  }
`;
export const listInvoices = /* GraphQL */ `
  query ListInvoices(
    $filter: ModelInvoiceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInvoices(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        createdAt
        updatedAt
        paymentDate
        insurer
        claimNo
        patient
        provider
        amount
        paymentType
        note
        invoiceDoc
        chequeDoc
        status
        claimDisbursedToProvider
        createdBy
        updatedBy
      }
      nextToken
    }
  }
`;
export const getProduct = /* GraphQL */ `
  query GetProduct($id: ID!) {
    getProduct(id: $id) {
      id
      productCode
      category
      description
      storeID
      store {
        id
        name
        createdAt
        updatedAt
      }
      audits {
        items {
          id
          productID
          auditID
          expiry
          qty
          product {
            id
            productCode
            category
            description
            storeID
            package
            qty
            minStockQty
            supplier
            obsolete
            createdAt
            updatedAt
          }
          audit {
            id
            name
            note
            auditFrequency
            createdAt
            updatedAt
          }
          shelfID
          shelf {
            id
            name
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      package
      qty
      minStockQty
      supplier
      obsolete
      createdAt
      updatedAt
    }
  }
`;
export const listProducts = /* GraphQL */ `
  query ListProducts(
    $filter: ModelProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProducts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        productCode
        category
        description
        storeID
        store {
          id
          name
          createdAt
          updatedAt
        }
        audits {
          items {
            id
            productID
            auditID
            expiry
            qty
            shelfID
            createdAt
            updatedAt
          }
          nextToken
        }
        package
        qty
        minStockQty
        supplier
        obsolete
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getStore = /* GraphQL */ `
  query GetStore($id: ID!) {
    getStore(id: $id) {
      id
      name
      createdAt
      updatedAt
    }
  }
`;
export const listStores = /* GraphQL */ `
  query ListStores(
    $filter: ModelStoreFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStores(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getShelf = /* GraphQL */ `
  query GetShelf($id: ID!) {
    getShelf(id: $id) {
      id
      name
      createdAt
      updatedAt
    }
  }
`;
export const listShelfs = /* GraphQL */ `
  query ListShelfs(
    $filter: ModelShelfFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listShelfs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getProductAudit = /* GraphQL */ `
  query GetProductAudit($id: ID!) {
    getProductAudit(id: $id) {
      id
      productID
      auditID
      expiry
      qty
      product {
        id
        productCode
        category
        description
        storeID
        store {
          id
          name
          createdAt
          updatedAt
        }
        audits {
          items {
            id
            productID
            auditID
            expiry
            qty
            shelfID
            createdAt
            updatedAt
          }
          nextToken
        }
        package
        qty
        minStockQty
        supplier
        obsolete
        createdAt
        updatedAt
      }
      audit {
        id
        name
        products {
          items {
            id
            productID
            auditID
            expiry
            qty
            shelfID
            createdAt
            updatedAt
          }
          nextToken
        }
        note
        auditFrequency
        createdAt
        updatedAt
      }
      shelfID
      shelf {
        id
        name
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const listProductAudits = /* GraphQL */ `
  query ListProductAudits(
    $filter: ModelProductAuditFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProductAudits(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        productID
        auditID
        expiry
        qty
        product {
          id
          productCode
          category
          description
          storeID
          store {
            id
            name
            createdAt
            updatedAt
          }
          audits {
            nextToken
          }
          package
          qty
          minStockQty
          supplier
          obsolete
          createdAt
          updatedAt
        }
        audit {
          id
          name
          products {
            nextToken
          }
          note
          auditFrequency
          createdAt
          updatedAt
        }
        shelfID
        shelf {
          id
          name
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getAudit = /* GraphQL */ `
  query GetAudit($id: ID!) {
    getAudit(id: $id) {
      id
      name
      products {
        items {
          id
          productID
          auditID
          expiry
          qty
          product {
            id
            productCode
            category
            description
            storeID
            package
            qty
            minStockQty
            supplier
            obsolete
            createdAt
            updatedAt
          }
          audit {
            id
            name
            note
            auditFrequency
            createdAt
            updatedAt
          }
          shelfID
          shelf {
            id
            name
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      note
      auditFrequency
      createdAt
      updatedAt
    }
  }
`;
export const listAudits = /* GraphQL */ `
  query ListAudits(
    $filter: ModelAuditFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAudits(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        products {
          items {
            id
            productID
            auditID
            expiry
            qty
            shelfID
            createdAt
            updatedAt
          }
          nextToken
        }
        note
        auditFrequency
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getPurchaseOrder = /* GraphQL */ `
  query GetPurchaseOrder($id: ID!) {
    getPurchaseOrder(id: $id) {
      id
      name
      orderDoc
      invoiceDoc
      receiptDoc
      orderStatus
      delivered
      createdBy
      updatedBy
      createdAt
      amount
      supplier
      items {
        items {
          id
          productID
          purchaseOrderID
          qty
          price
          product {
            id
            productCode
            category
            description
            storeID
            package
            qty
            minStockQty
            supplier
            obsolete
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      updatedAt
    }
  }
`;
export const listPurchaseOrders = /* GraphQL */ `
  query ListPurchaseOrders(
    $filter: ModelPurchaseOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPurchaseOrders(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        orderDoc
        invoiceDoc
        receiptDoc
        orderStatus
        delivered
        createdBy
        updatedBy
        createdAt
        amount
        supplier
        items {
          items {
            id
            productID
            purchaseOrderID
            qty
            price
            createdAt
            updatedAt
          }
          nextToken
        }
        updatedAt
      }
      nextToken
    }
  }
`;
export const getItem = /* GraphQL */ `
  query GetItem($id: ID!) {
    getItem(id: $id) {
      id
      productID
      purchaseOrderID
      qty
      price
      product {
        id
        productCode
        category
        description
        storeID
        store {
          id
          name
          createdAt
          updatedAt
        }
        audits {
          items {
            id
            productID
            auditID
            expiry
            qty
            shelfID
            createdAt
            updatedAt
          }
          nextToken
        }
        package
        qty
        minStockQty
        supplier
        obsolete
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const listItems = /* GraphQL */ `
  query ListItems(
    $filter: ModelItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listItems(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        productID
        purchaseOrderID
        qty
        price
        product {
          id
          productCode
          category
          description
          storeID
          store {
            id
            name
            createdAt
            updatedAt
          }
          audits {
            nextToken
          }
          package
          qty
          minStockQty
          supplier
          obsolete
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getReport = /* GraphQL */ `
  query GetReport($tag: String!, $createdAt: AWSDateTime!) {
    getReport(tag: $tag, createdAt: $createdAt) {
      id
      tag
      amount
      createdAt
      createdBy
      reportFile
      updatedAt
    }
  }
`;
export const listReports = /* GraphQL */ `
  query ListReports(
    $tag: String
    $createdAt: ModelStringKeyConditionInput
    $filter: ModelReportFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listReports(
      tag: $tag
      createdAt: $createdAt
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        tag
        amount
        createdAt
        createdBy
        reportFile
        updatedAt
      }
      nextToken
    }
  }
`;
export const getNswPublicHoliday = /* GraphQL */ `
  query GetNswPublicHoliday($id: ID!) {
    getNSWPublicHoliday(id: $id) {
      id
      name
      createdAt
      updatedAt
    }
  }
`;
export const listNswPublicHolidays = /* GraphQL */ `
  query ListNswPublicHolidays(
    $filter: ModelNSWPublicHolidayFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listNSWPublicHolidays(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const timeSheetByStaffDate = /* GraphQL */ `
  query TimeSheetByStaffDate(
    $staffID: String
    $arrivalTime: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTimeSheetFilterInput
    $limit: Int
    $nextToken: String
  ) {
    timeSheetByStaffDate(
      staffID: $staffID
      arrivalTime: $arrivalTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        staffID
        arrivalTime
        departureTime
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const itemsByPurchaseOrder = /* GraphQL */ `
  query ItemsByPurchaseOrder(
    $purchaseOrderID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    itemsByPurchaseOrder(
      purchaseOrderID: $purchaseOrderID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        productID
        purchaseOrderID
        qty
        price
        product {
          id
          productCode
          category
          description
          storeID
          store {
            id
            name
            createdAt
            updatedAt
          }
          audits {
            nextToken
          }
          package
          qty
          minStockQty
          supplier
          obsolete
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getContact = /* GraphQL */ `
  query GetContact($id: ID!) {
    getContact(id: $id) {
      id
      firstName
      lastName
      phone
      email
      companyName
      createdAt
      updatedAt
    }
  }
`;
export const listContacts = /* GraphQL */ `
  query ListContacts(
    $filter: ModelContactFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listContacts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        firstName
        lastName
        phone
        email
        companyName
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const contactByPhone = /* GraphQL */ `
  query ContactByPhone(
    $phone: String
    $sortDirection: ModelSortDirection
    $filter: ModelContactFilterInput
    $limit: Int
    $nextToken: String
  ) {
    contactByPhone(
      phone: $phone
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        firstName
        lastName
        phone
        email
        companyName
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
